import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PartnerRegister } from '../api/PartnerRegister';
import { OnevnService } from '../service/onevn.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  dataPost: PartnerRegister = {};
  myForm: FormGroup;
  constructor(
    private onevn: OnevnService,
    private formBuilder: FormBuilder,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.reset();
  }
  reset() {
    this.dataPost = {};
    this.dataPost.idfield = null;
    this.dataPost.language = 'vi';
    this.dataPost.idpartner = null;
    this.dataPost.idtypepartner = null;
    this.dataPost.codetypepartner = null;
    this.dataPost.code = null;
    this.dataPost.parent = null;
    this.dataPost.name = null;
    this.dataPost.sex = null;
    this.dataPost.idcountry = 964;
    this.dataPost.idcity = null;
    this.dataPost.address = null;
    this.dataPost.lon = null;
    this.dataPost.lat = null;
    this.dataPost.phone = null;
    this.dataPost.website = null;
    this.dataPost.email = null;
    this.dataPost.fax = null;
    this.dataPost.taxcode = null;
    this.dataPost.birthday = null;
    this.dataPost.description = null;
    this.dataPost.datecreate = null;
    this.dataPost.yearmonthday = null;
    this.dataPost.idsource = null;
    this.dataPost.idtype = null;
    this.dataPost.idgroup = null;
    this.dataPost.idlevel = null;
    this.dataPost.idaccount = null;
    this.dataPost.nameaccount = null;
    this.dataPost.idcreate = null;
    this.dataPost.namecreate = null;
    this.dataPost.type = 0;
    this.dataPost.ispersonal = null;
    this.dataPost.idnation = null;
    this.dataPost.namenation = null;
    this.dataPost.numbercard = null;
    this.dataPost.datecard = null;
    this.dataPost.placecard = null;
    this.dataPost.linkfacebook = null;
    this.dataPost.linkzalo = null;
    this.dataPost.linkyoutobe = null;
    this.dataPost.uniquename = null;
    this.dataPost.acchuman = {};
    this.dataPost.lang = [];
    this.dataPost.solve = [];
    this.dataPost.listkey = [];
    this.dataPost.setting = {};
    this.dataPost.supportinsure = false;
    this.dataPost.listbrand = [];
  }

  ngOnInit(): void {
    this.myForm = this.formBuilder.group({
      idfield: ['null', Validators.required],
      name: ['', Validators.required],
      address: ['', Validators.required],
      uniquename: ['', Validators.required],
      namecreate: ['', Validators.required],
      phone: ['', Validators.required],
      email: ['', Validators.required],
      user: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(4)]],
    });
  }
  setUniquename(data: string) {
    if (data) {
      this.dataPost.uniquename = this.myForm.value.uniquename;
    }
  }
  sendPost() {
    console.log(this.myForm.valid);
    if (this.myForm.valid) {
      this.dataPost.acchuman.infoacc = {
        username: this.myForm.value.user,
        pass: this.myForm.value.password,
        idtype: 10,
        deleted: false,
        datecreate: null,
        status: true,
      };
      this.dataPost.acchuman.user = this.myForm.value.user;
      this.dataPost.acchuman.pass = this.myForm.value.password;
      this.dataPost.acchuman.email = this.myForm.value.email;
      this.dataPost.acchuman.uniquename = this.myForm.value.uniquename;
      const dataInsert: PartnerRegister = Object.assign(
        {},
        this.dataPost,
        this.myForm.value
      );
      console.log(dataInsert);
      if (!dataInsert.idpartner) {
        this.onevn
          .post('Partner/Register', dataInsert)
          .subscribe((res: any) => {
            if (res.status == 'success') {
              alert('Đăng ký thành công!');
              this.document.location.href = 'http://demo.oliu.io/';
            } else {
              if (res.status == '405') {
                alert('Tên miền đã được sử dụng! Vui lòng nhập lại');
              }
              if (res.status == '408') {
                alert('Email đã được sử dụng! Vui lòng nhập lại');
              }
              if (res.status == 'error') {
                alert('Bạn đăng ký không thành công! Vui lòng kiểm tra lại');
              }
            }
          });
      }
    } else {
      alert('Bạn chưa nhập đủ thông tin, vui lòng nhập lại!');
    }
  }
}
